import CruiseCardShipIcon from 'components/CruiseCard/CruiseCardShip/CruiseCardShipIcon/CruiseCardShipIcon';
import { CruiseSearchContext } from 'contexts/CruiseSearchContext';
import { useContext } from 'react';
import { MapCruiseCardShipBase, MapCruiseCardShipLabel, MapCruiseCardShipName } from './MapCruiseCardShip.styles';
import { MapCruiseCardShipProps } from './MapCruiseCardShip.types';

function MapCruiseCardShip({ shipName }: MapCruiseCardShipProps) {
  const { globalization }: any = useContext(CruiseSearchContext);
  const { pricingPanelDictionary } = (globalization?.dictionaries || {});
  const { labelOnboard } = pricingPanelDictionary;

  return (
    <MapCruiseCardShipBase>
      <CruiseCardShipIcon/>
      <MapCruiseCardShipLabel>{labelOnboard}:</MapCruiseCardShipLabel>
      <MapCruiseCardShipName>{shipName}</MapCruiseCardShipName>
    </MapCruiseCardShipBase>
  );
}

export default MapCruiseCardShip;